import { isAfter, isBefore, isValid, isWithinInterval, parse } from "date-fns";

const parseDate = (dateText: string, template: string, minDate?: Date, maxDate?: Date): Date | null => {
  const parsedDate = parse(dateText, template, new Date());
  if (!isValid(parsedDate)) {
    return null;
  }
  const minDateWithoutTime = minDate && new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
  const maxDateWithoutTime = maxDate && new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
  if (
    minDateWithoutTime &&
    maxDateWithoutTime &&
    !isWithinInterval(parsedDate, { start: minDateWithoutTime, end: maxDateWithoutTime })
  ) {
    return null;
  }
  if (minDateWithoutTime && isBefore(parsedDate, minDateWithoutTime)) {
    return null;
  }
  if (maxDateWithoutTime && isAfter(parsedDate, maxDateWithoutTime)) {
    return null;
  }
  return isValid(parsedDate) ? parsedDate : null;
};

export default parseDate;
